const map = {
	"./de.po.json": 82782,
	"./en.po.json": 87654,
	"./es.po.json": 45251,
	"./fr.po.json": 50959,
	"./ja.po.json": 14432,
	"./nl.po.json": 32777,
	"./pl.po.json": 58003,
	"./pt.po.json": 27067,
	"./ru.po.json": 76268,
	"./te.po.json": 78062
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87310;